import {
  isAnalyzedEventVideoFalsePositive,
  isAnalyzedEventVideoImpact,
  isEventVideoReview,
} from '../modules/sensor-data/utils/videoRowSeverity';

export const videoDisplayLabel = (video) => {
  if (video?.videoLabel === 'keep_alive') return 'Keep Alive';
  if (video?.type === 'event') {
    if (isEventVideoReview(video)) return 'Review';
    if (isAnalyzedEventVideoFalsePositive(video)) return 'False Positive';
    if (isAnalyzedEventVideoImpact(video)) return 'Confirmed Impact';
    return video?.severity ? String(video.severity) : 'Alert Event';
  }
  return 'Health';
};

/**
 * Clips before 29 Oct 2026 were stored 9 hours behind the clock burned into
 * the picture. From that date on, recordedAt already matches the bridge zone.
 */
const CAMERA_OVERLAY_CUTOFF = '2026-10-29';
const PRE_CUTOFF_OVERLAY_SHIFT_MS = 9 * 60 * 60 * 1000;

const zonedDateKey = (date, timeZone) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value;
  return `${get('year')}-${get('month')}-${get('day')}`;
};

/**
 * Clock burned into the video. recordedAt is a UTC instant; the overlay
 * prints the bridge's local time. Pass that zone so the label matches the
 * footage. Callers without a zone keep the UTC digits (dedupe key).
 */
export const formatVideoRecordedAt = (iso, timeZone) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  const zone = timeZone || 'UTC';
  let instant = d;
  if (timeZone) {
    try {
      if (zonedDateKey(d, zone) < CAMERA_OVERLAY_CUTOFF) {
        instant = new Date(d.getTime() + PRE_CUTOFF_OVERLAY_SHIFT_MS);
      }
    } catch {
      instant = d;
    }
  }
  try {
    return instant.toLocaleString('en-US', { timeZone: zone });
  } catch {
    return instant.toLocaleString('en-US', { timeZone: 'UTC' });
  }
};

export const formatVideoRow = (video) =>
  `${video.dataLoggerSerialNo}_${formatVideoRecordedAt(video.recordedAt)}`;

export const isEventVideo = (video) =>
  video?.type === 'event' && video?.videoLabel !== 'keep_alive';

export const isHealthVideo = (video) =>
  video?.type === 'health' || video?.videoLabel === 'keep_alive';
